import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useBulkUpdateScheduleOverrides = () => {
  return useMutation({
    mutationFn: bulkUpdateScheduleOverrides,
    onSuccess: async () => {
      await queryClient.cancelQueries({
        queryKey: queryKeys.schedulePreview.details(),
      });
      queryClient.removeQueries({
        queryKey: queryKeys.schedulePreview.details(),
      });

      queryClient.invalidateQueries(queryKeys.getCalendarEvents.details());
      queryClient.invalidateQueries(
        queryKeys.getCalendarSidebarDetails.details(),
      );
      queryClient.invalidateQueries(queryKeys.scheduleOverview.invalidateAll());
    },
  });
};

const bulkUpdateScheduleOverrides = async (changeSetIds: number[]) => {
  const data = {
    data: {
      changeSetIds,
    },
  };

  return requestCCApi({ url: '/commitChangeSet', method: 'POST', data });
};
